import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptQueryString, transformRequest } from '../../../utils/API/requestMiddleware';
import { defautBaseQuery } from '../../../utils/API/fetchBaseQuery';
import { transformErrorResponse, transformSucessResponse } from "../../../utils/API/responseMiddleware";

const corporateMemberApi = createApi({
    reducerPath: 'corporateMemberApi',
    baseQuery: defautBaseQuery,
    endpoints: (builder) => ({
        getAllCorporateMemberList: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Membership/GetAllCorporateMemberList`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCorporateMemberDetailsByCorporateMemberId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Membership/GetCorporateMemberDetailsByCorporateMemberId?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllKeyPositionsDetailByCorporateMemberId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Membership/GetAllKeyPositionsDetailByCorporateMemberId?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addEditCorporateRepresentativeInformation: builder.mutation({
            query: (details) => ({
                url: '/Membership/AddEditCorporateRepresentativeInformation',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addCorporateRepresentativeKeyPositionInformation: builder.mutation({
            query: (details) => ({
                url: '/Membership/AddCorporateRepresentativeKeyPositionInformation',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        corporateMembershipApplicationTaskList: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Membership/CorporateMembershipApplicationTaskList`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateCorporateMemberDetailsByAdmin: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Membership/UpdateCorporateMemberDetailsByAdmin`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        checkUENNumberExistOrNot: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Membership/CheckUENNumberExistOrNot`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateCorporateMemberBusinessActivityByAdmin: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Membership/UpdateCorporateMemberBusinessActivityByAdmin`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateCorporateMemberOtherInformationByAdmin: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Membership/UpdateCorporateMemberOtherInformationByAdmin`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCorporateRepresentativeInformationById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Membership/GetCorporateRepresentativeInformationById?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        adminSelectReinstatement: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Membership/AdminSelectReinstatement`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
         getOptExpiryOrOptTerminationById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Dashboard/GetOptExpiryOrOptTerminationById?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
         saveOptExpiryOrOptTerminationByAdmin: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Dashboard/SaveOptExpiryOrOptTerminationByAdmin`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getSGBCCorporateMemberFinacationInformationById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Dashboard/GetSGBCCorporateMemberFinacationInformationById?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getReinstateMentButtonActive: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Dashboard/GetReinstateMentButtonActiveById?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAnalyticsInfomrationByCorporateMemberId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Dashboard/GetAnalyticsInfomrationByCorporateMemberId?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addReinstatementToNewApplicationbyAdmin: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Dashboard/AddReinstatementToNewApplicationbyAdmin`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getSGBCCorporateRepresentativeLogByMemberId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Employee/GetSGBCCorporateRepresentativeLogByMemberId?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
})

export const {
    useGetAllCorporateMemberListMutation,
    useLazyGetCorporateMemberDetailsByCorporateMemberIdQuery,
    useLazyGetAllKeyPositionsDetailByCorporateMemberIdQuery,
    useAddEditCorporateRepresentativeInformationMutation,
    useCorporateMembershipApplicationTaskListMutation,
    useUpdateCorporateMemberDetailsByAdminMutation,
    useCheckUENNumberExistOrNotMutation,
    useUpdateCorporateMemberBusinessActivityByAdminMutation,
    useUpdateCorporateMemberOtherInformationByAdminMutation,
    useLazyGetCorporateRepresentativeInformationByIdQuery,
    useAdminSelectReinstatementMutation,
    useLazyGetOptExpiryOrOptTerminationByIdQuery,
    useSaveOptExpiryOrOptTerminationByAdminMutation,
    useLazyGetSGBCCorporateMemberFinacationInformationByIdQuery,
    useLazyGetReinstateMentButtonActiveQuery,
    useLazyGetAnalyticsInfomrationByCorporateMemberIdQuery,
    useAddReinstatementToNewApplicationbyAdminMutation,
    useAddCorporateRepresentativeKeyPositionInformationMutation,
    useLazyGetSGBCCorporateRepresentativeLogByMemberIdQuery
} = corporateMemberApi;

export default corporateMemberApi;